/* Havluland theme behaviour. No dependencies. Untrusted strings are only ever written with textContent. */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var theme = window.theme || { routes: {} };
  var routes = theme.routes || {};
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    var amount = (Number(cents) / 100).toFixed(2);
    var fmt = theme.moneyFormat || '${{amount}}';
    var withComma = amount.replace('.', ',');
    var noDecimals = String(Math.round(Number(cents) / 100));
    var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_with_comma_separator') return withComma;
      if (key === 'amount_no_decimals') return noDecimals;
      return amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    });
    var tmp = document.createElement('span');
    tmp.innerHTML = out.replace(/<[^>]*>/g, '');
    return tmp.textContent;
  }
  function sizedUrl(src, width) {
    if (!src) return '';
    var url = src.indexOf('//') === 0 ? 'https:' + src : src;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }
  /* Smallest of the given widths that covers el's drawn width on this screen. */
  function fitWidth(el, widths) {
    var need = el ? el.clientWidth * (window.devicePixelRatio || 1) : 0;
    for (var i = 0; i < widths.length; i++) if (need && widths[i] >= need) return widths[i];
    return widths[widths.length - 1];
  }

  /* Background image queue: two downloads at a time, so warming never crowds out what is on screen.
     Jobs are URLs or lazy <img> elements (switched to eager, so the browser keeps its srcset choice). */
  var warmQueue = [];
  var warmSeen = {};
  var warmBusy = 0;
  function warmNext() {
    while (warmBusy < 2 && warmQueue.length) {
      var job = warmQueue.shift();
      if (typeof job !== 'string' && job.complete && job.naturalWidth) continue;
      warmRun(job);
    }
  }
  /* One job in its own scope, so each download frees exactly its own slot. */
  function warmRun(job) {
    warmBusy++;
    var settled = false;
    function done() { if (settled) return; settled = true; warmBusy--; setTimeout(warmNext, 0); }
    setTimeout(done, 10000); /* never let one stalled image hold a slot */
    if (typeof job === 'string') {
      var pic = new Image();
      pic.onload = pic.onerror = done;
      pic.src = job;
    } else {
      job.addEventListener('load', done, { once: true });
      job.addEventListener('error', done, { once: true });
      job.loading = 'eager';
    }
  }
  function warmUrl(src) {
    if (!src || warmSeen[src]) return;
    warmSeen[src] = true;
    warmQueue.push(src);
    warmNext();
  }
  function warmImg(img) {
    if (!img || img.loading !== 'lazy') return;
    warmQueue.push(img);
    warmNext();
  }
  function afterLoad(fn) {
    if (document.readyState === 'complete') setTimeout(fn, 300);
    else window.addEventListener('load', function () { setTimeout(fn, 300); });
  }

  /* Once the page has loaded, every remaining lazy image downloads in page order (card hover images last),
     so sections further down are drawn before the visitor scrolls to them. Skipped when Save-Data is on. */
  function initWarm() {
    afterLoad(function () {
      if (navigator.connection && navigator.connection.saveData) return;
      var hover = $$('[data-card] a > span img');
      $$('img[loading="lazy"]').forEach(function (img) { if (hover.indexOf(img) < 0) warmImg(img); });
      hover.forEach(warmImg);
    });
  }

  function safePath(url) {
    return typeof url === 'string' && url.charAt(0) === '/' && url.charAt(1) !== '/' ? url : '/';
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function lockScroll(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }

  /* Overlays: drawers and dialogs share one open/close helper with focus return and Escape. */
  var openLayer = null;
  var lastFocus = null;
  function openPanel(node, opts) {
    if (!node) return;
    if (openLayer && openLayer !== node) closePanel(openLayer);
    lastFocus = document.activeElement;
    if (node.classList.contains('drawer-wrap')) {
      node.classList.add('is-open');
      node.removeAttribute('inert');
      node.setAttribute('aria-hidden', 'false');
    } else {
      node.hidden = false;
    }
    openLayer = node;
    lockScroll(true);
    var focusTarget = (opts && opts.focus) ? $(opts.focus, node) : $('button, a, input', node);
    if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 50);
  }
  function closePanel(node) {
    node = node || openLayer;
    if (!node) return;
    if (node.classList.contains('drawer-wrap')) {
      node.classList.remove('is-open');
      node.setAttribute('inert', '');
      node.setAttribute('aria-hidden', 'true');
    } else {
      node.hidden = true;
    }
    if (openLayer === node) openLayer = null;
    lockScroll(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openLayer) {
      if (openLayer.hasAttribute('data-popup-dialog')) { popupClose(); return; }
      closePanel(openLayer);
    }
  });

  /* ---------------------------------------------------------------- header */
  function initHeader() {
    var header = $('[data-header]');
    if (header) {
      var onScroll = function () { header.classList.toggle('header-scrolled', window.scrollY > 10); };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    var bar = $('[data-announcement]');
    if (bar) {
      var msgs = $$('[data-message]', bar);
      if (msgs.length > 1) {
        var i = 0;
        setInterval(function () {
          bar.classList.add('is-rotating');
          msgs[i].hidden = true;
          i = (i + 1) % msgs.length;
          msgs[i].hidden = false;
        }, Number(bar.getAttribute('data-interval')) || 4500);
      }
    }

    $$('[data-mega]').forEach(function (mega) {
      var item = mega.parentElement;
      $$('a', mega).forEach(function (a) { a.addEventListener('click', function () { mega.classList.add('is-closed'); }); });
      item.addEventListener('mouseleave', function () { mega.classList.remove('is-closed'); });
    });

    var menu = $('[data-menu]');
    $$('[data-open-menu]').forEach(function (b) { b.addEventListener('click', function () { openPanel(menu); b.setAttribute('aria-expanded', 'true'); }); });
    $$('[data-close-menu]').forEach(function (b) {
      b.addEventListener('click', function () { closePanel(menu); var t = $('[data-open-menu]'); if (t) t.setAttribute('aria-expanded', 'false'); });
    });
    if (menu) $$('a', menu).forEach(function (a) { a.addEventListener('click', function () { closePanel(menu); }); });
  }

  /* Collapsible groups: mobile menu, footer columns, product accordions. */
  function initCollapsibles() {
    $$('[data-collapse-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('[data-collapsible]');
        var open = !wrap.classList.contains('is-open');
        wrap.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var list = $('[data-collapse-list]', wrap);
        if (list) list.classList.toggle('hidden', !open);
      });
    });
  }

  /* ---------------------------------------------------------------- search */
  function initSearch() {
    var dialog = $('[data-search]');
    if (!dialog) return;
    var input = $('[data-search-input]', dialog);
    var results = $('[data-search-results]', dialog);
    var label = $('[data-search-label]', dialog);
    var initial = results.innerHTML;
    var timer = null;
    var seq = 0;

    $$('[data-open-search]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); openPanel(dialog, { focus: '[data-search-input]' }); });
    });
    $$('[data-close-search]', dialog).forEach(function (b) { b.addEventListener('click', function () { closePanel(dialog); }); });

    function render(products, q) {
      results.textContent = '';
      label.textContent = products.length + ' results';
      products.forEach(function (p) {
        var a = el('a', 'group');
        a.href = safePath(p.url);
        var box = el('div', 'aspect-[4/5] bg-mist overflow-hidden');
        if (p.image) {
          var img = el('img', 'size-full object-cover transition-transform duration-300 group-hover:scale-105');
          img.src = sizedUrl(p.image, 400);
          img.alt = p.title || '';
          img.loading = 'lazy';
          box.appendChild(img);
        }
        a.appendChild(box);
        a.appendChild(el('p', 'mt-2 text-[15px] font-semibold', p.title));
        a.appendChild(el('p', 'text-[14px] text-ink-soft', p.price != null ? money(Math.round(parseFloat(p.price) * 100)) : ''));
        results.appendChild(a);
      });
      if (!products.length) results.appendChild(el('p', 'col-span-full text-ink-soft', T('noResults', 'No results for') + ' "' + q + '".'));
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (!q) { results.innerHTML = initial; label.textContent = T('popular', 'Popular'); return; }
      timer = setTimeout(function () {
        var mine = ++seq;
        var url = (routes.predictiveSearch || '/search/suggest.json') + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8';
        fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (mine !== seq) return;
            var list = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            render(list, q);
          })
          .catch(function () {});
      }, 200);
    });
  }

  /* ---------------------------------------------------------------- cart */
  var drawer = null;
  function setCount(n) { $$('[data-cart-count]').forEach(function (c) { c.textContent = n; }); }

  function renderCart(cart) {
    setCount(cart.item_count);
    if (!drawer) return;
    var empty = $('[data-cart-empty]', drawer);
    var filled = $('[data-cart-filled]', drawer);
    empty.hidden = cart.item_count > 0;
    filled.hidden = cart.item_count === 0;
    var sub = $('[data-cart-subtotal]', drawer);
    if (sub) sub.textContent = money(cart.total_price);
    var list = $('[data-cart-lines]', drawer);
    list.textContent = '';
    cart.items.forEach(function (item, idx) {
      var line = idx + 1;
      var li = el('li', 'py-5 flex gap-4');
      var link = el('a', 'w-[88px] shrink-0 aspect-[4/5] bg-mist overflow-hidden');
      link.href = safePath(item.url);
      if (item.image) {
        var img = el('img', 'size-full object-cover');
        img.src = sizedUrl(item.image, 200);
        img.alt = '';
        link.appendChild(img);
      }
      li.appendChild(link);
      var body = el('div', 'flex-1 min-w-0');
      var top = el('div', 'flex justify-between gap-3');
      top.appendChild(el('p', 'text-[15px] font-semibold leading-snug', item.product_title));
      top.appendChild(el('p', 'text-[15px] font-semibold', money(item.final_line_price)));
      body.appendChild(top);
      if (!item.product_has_only_default_variant && item.variant_title) body.appendChild(el('p', 'text-[13px] text-ink-soft mt-1', item.variant_title));
      var row = el('div', 'mt-3 flex items-center gap-4');
      var qty = el('div', 'inline-flex items-center border border-line rounded-md h-9');
      var minus = el('button', 'w-9 grid place-items-center', '−');
      minus.type = 'button';
      minus.setAttribute('aria-label', 'Decrease');
      var count = el('span', 'w-6 text-center text-[14px]', String(item.quantity));
      var plus = el('button', 'w-9 grid place-items-center', '+');
      plus.type = 'button';
      plus.setAttribute('aria-label', 'Increase');
      minus.addEventListener('click', function () { changeLine(line, item.quantity - 1); });
      plus.addEventListener('click', function () { changeLine(line, item.quantity + 1); });
      qty.appendChild(minus); qty.appendChild(count); qty.appendChild(plus);
      var remove = el('button', 'text-[12px] underline text-ink-soft hover:text-ink', 'Remove');
      remove.type = 'button';
      remove.addEventListener('click', function () { changeLine(line, 0); });
      row.appendChild(qty); row.appendChild(remove);
      body.appendChild(row);
      li.appendChild(body);
      list.appendChild(li);
    });
    var sug = $('[data-cart-suggestion]', drawer);
    if (sug) {
      var handle = sug.getAttribute('data-handle');
      sug.hidden = cart.items.some(function (i) { return i.handle === handle; });
    }
  }
  function fetchCart() {
    return fetch((routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function changeLine(line, quantity) {
    return fetch(routes.cartChange || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) })
    }).then(function (r) { return r.json(); }).then(renderCart).catch(function () { window.location.href = routes.cart || '/cart'; });
  }
  function openCart() {
    if (!drawer) { window.location.href = routes.cart || '/cart'; return; }
    openPanel(drawer);
  }

  function initCart() {
    drawer = $('[data-cart-drawer]');
    $$('[data-open-cart]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); fetchCart().then(renderCart).catch(function () {}); openCart(); }); });
    if (drawer) $$('[data-close-cart]', drawer).forEach(function (b) { b.addEventListener('click', function () { closePanel(drawer); }); });
    if (drawer && $('[data-cart-filled]', drawer) && !$('[data-cart-filled]', drawer).hidden) fetchCart().then(renderCart).catch(function () {});

    /* Any product form on the page adds through AJAX; on failure it falls back to a normal submit. */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      var buttons = $$('button[type="submit"], button:not([type])', form).concat($$('button[form="' + form.id + '"]'));
      buttons.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
      var errorBox = $('[data-form-error]', form);
      if (errorBox) errorBox.hidden = true;
      fetch(routes.cartAdd || '/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) throw res.data;
          return fetchCart().then(function (cart) { renderCart(cart); openCart(); });
        })
        .catch(function (err) {
          if (errorBox && err && (err.description || err.message)) {
            errorBox.textContent = err.description || err.message;
            errorBox.hidden = false;
          } else if (!errorBox) {
            form.submit();
          }
        })
        .then(function () { buttons.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); }); });
    });
  }

  /* ---------------------------------------------------------------- reveal + image fade */
  function initReveal() {
    var els = $$('.reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (e) { io.observe(e); });
  }
  function initImgFade() {
    $$('img.img-fade').forEach(function (img) {
      if (img.complete && img.naturalWidth) img.classList.add('loaded');
      else {
        img.addEventListener('load', function () { img.classList.add('loaded'); });
        img.addEventListener('error', function () { img.classList.add('loaded'); });
      }
    });
  }

  /* ---------------------------------------------------------------- home */
  function initHero() {
    $$('[data-hero]').forEach(function (hero) {
      var slides = $$('[data-slide]', hero);
      var dots = $$('[data-dot]', hero);
      if (slides.length < 2) return;
      var i = 0, paused = false;
      function go(n) {
        hero.classList.add('hero-animate');
        slides[i].classList.remove('is-active');
        slides[i].setAttribute('aria-hidden', 'true');
        slides[i].setAttribute('inert', '');
        if (dots[i]) dots[i].setAttribute('aria-current', 'false');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active');
        slides[i].removeAttribute('aria-hidden');
        slides[i].removeAttribute('inert');
        if (dots[i]) dots[i].setAttribute('aria-current', 'true');
      }
      dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
      hero.addEventListener('mouseenter', function () { paused = true; });
      hero.addEventListener('mouseleave', function () { paused = false; });
      if (!reduceMotion) setInterval(function () { if (!paused && !document.hidden) go(i + 1); }, Number(hero.getAttribute('data-interval')) || 6500);
    });
  }
  function initTabs() {
    $$('[data-tabs]').forEach(function (root) {
      var tabs = $$('[data-tab]', root);
      var panels = $$('[data-panel]', root);
      tabs.forEach(function (t, n) {
        t.addEventListener('click', function () {
          root.classList.add('is-swapped');
          tabs.forEach(function (x, m) { x.setAttribute('aria-selected', m === n ? 'true' : 'false'); });
          panels.forEach(function (p, m) { p.hidden = m !== n; });
        });
      });
      /* Hidden panels' card images download in the background, so switching tabs shows them at once. */
      afterLoad(function () { panels.forEach(function (p) { $$('[data-card] > a > img', p).forEach(warmImg); }); });
    });
  }
  function initSliders() {
    $$('[data-slider]').forEach(function (root) {
      var slides = $$('[data-slide]', root);
      if (slides.length < 2) return;
      var i = 0;
      var dots = $$('[data-dots] button', root);
      function show(n) {
        if (n === i) return;
        root.classList.add('is-swapped');
        slides[i].hidden = true;
        i = (n + slides.length) % slides.length;
        slides[i].hidden = false;
        dots.forEach(function (d, m) { if (m === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      }
      function go(d) { show(i + d); }
      function tap(fn) { return function () { root.removeAttribute('data-dir'); fn(); }; }
      $$('[data-prev]', root).forEach(function (b) { b.addEventListener('click', tap(function () { go(-1); })); });
      $$('[data-next]', root).forEach(function (b) { b.addEventListener('click', tap(function () { go(1); })); });
      dots.forEach(function (d, m) { d.addEventListener('click', tap(function () { show(m); })); });
      /* Drag or swipe (finger or mouse) to change review: the slide follows the pointer, then the next one slides in
         from that side. Vertical page scrolling is left to the browser (touch-action: pan-y in CSS). */
      if (root.hasAttribute('data-swipe')) {
        var sx = null, sy = 0, dx = 0, pid = null, dragging = false, dragged = false;
        root.addEventListener('pointerdown', function (e) {
          dragged = false;
          if ((e.pointerType === 'mouse' && e.button !== 0) || e.target.closest('button')) return;
          sx = e.clientX; sy = e.clientY; dx = 0; pid = e.pointerId; dragging = false;
          if (e.pointerType === 'mouse') e.preventDefault(); /* no text selection while dragging with a mouse */
        });
        root.addEventListener('pointermove', function (e) {
          if (sx === null || e.pointerId !== pid) return;
          dx = e.clientX - sx;
          if (!dragging) {
            if (Math.abs(dx) < 8) return;
            if (Math.abs(e.clientY - sy) > Math.abs(dx)) { sx = null; return; }
            dragging = true;
            try { root.setPointerCapture(pid); } catch (err) {}
            root.classList.add('is-dragging');
          }
          e.preventDefault();
          slides[i].style.transform = 'translateX(' + dx + 'px)';
          slides[i].style.opacity = String(1 - Math.min(Math.abs(dx) / 500, 0.4));
        });
        function release(e) {
          if (sx === null || e.pointerId !== pid) return;
          sx = null;
          if (!dragging) return;
          dragging = false;
          dragged = true;
          /* The click that ends a mouse drag arrives right after pointerup; a touch swipe sends none, so clear the flag either way. */
          setTimeout(function () { dragged = false; }, 0);
          root.classList.remove('is-dragging');
          var cur = slides[i];
          if (Math.abs(dx) > 50) {
            root.setAttribute('data-dir', dx < 0 ? 'next' : 'prev');
            go(dx < 0 ? 1 : -1);
          }
          cur.style.transform = '';
          cur.style.opacity = '';
        }
        root.addEventListener('pointerup', release);
        root.addEventListener('pointercancel', release);
        /* A drag must not also follow the "Shop now" link or drag the photo. */
        root.addEventListener('click', function (e) { if (dragged) { e.preventDefault(); e.stopPropagation(); dragged = false; } }, true);
        root.addEventListener('dragstart', function (e) { e.preventDefault(); });
      }
      /* Hidden slides are lazy, which would only start their download on the arrow click: fetch them in the background now. */
      afterLoad(function () { slides.forEach(function (sl) { $$('img', sl).forEach(warmImg); }); });
    });
  }

  /* Colour image for a card swatch: 540w is enough unless the card is drawn wider than that. */
  function swatchSrc(s, img) {
    var w = img ? img.clientWidth * (window.devicePixelRatio || 1) : 0;
    return (w && w <= 540 && s.getAttribute('data-img-sm')) || s.getAttribute('data-img');
  }

  /* Product card colour swatches swap the image and price. */
  function initCards() {
    document.addEventListener('mouseover', swatch);
    document.addEventListener('focusin', swatch);
    document.addEventListener('click', swatch);
    /* As soon as a finger or pointer reaches a card's swatch row, fetch that card's colour images so a tap swaps instantly. */
    function warmRow(e) {
      var row = e.target.closest && e.target.closest('[data-card] [role="radiogroup"]');
      if (!row || row.hasAttribute('data-warmed')) return;
      row.setAttribute('data-warmed', '');
      var img = $('a > img', row.closest('[data-card]'));
      $$('.swatch', row).forEach(function (s) { var src = swatchSrc(s, img); if (src) warmUrl(src); });
    }
    document.addEventListener('pointerover', warmRow, { passive: true });
    document.addEventListener('touchstart', warmRow, { passive: true });
    function swatch(e) {
      var s = e.target.closest && e.target.closest('[data-card] .swatch');
      if (!s) return;
      var card = s.closest('[data-card]');
      $$('.swatch', card).forEach(function (x) { x.setAttribute('aria-checked', x === s ? 'true' : 'false'); });
      var img = $('a > img', card);
      var src = swatchSrc(s, img);
      if (img && src) { img.removeAttribute('srcset'); img.src = src; }
      var price = $('[data-card-price]', card);
      var comp = $('[data-card-compare]', card);
      var compare = s.getAttribute('data-compare');
      if (price) { price.textContent = s.getAttribute('data-price'); price.className = compare ? 'text-coral font-semibold' : ''; }
      if (comp) { comp.textContent = compare || ''; comp.hidden = !compare; }
      var id = $('[data-card-variant]', card);
      var btn = id && id.form && $('button[type="submit"]', id.form);
      if (id && s.getAttribute('data-variant')) {
        id.value = s.getAttribute('data-variant');
        var out = s.hasAttribute('data-soldout');
        btn.disabled = out;
        btn.textContent = out ? 'Sold out' : 'Add to bag';
      }
    }
  }

  /* ---------------------------------------------------------------- product page */
  function initProduct() {
    var root = $('[data-product]');
    if (!root) return;
    var json = $('[data-product-json]', root);
    var product;
    try { product = JSON.parse(json.textContent); } catch (err) { return; }
    var form = $('[data-product-form]', root);
    var idInput = $('[data-variant-id]', root);
    var current = product.variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || product.variants[0];
    var selected = current.options.slice();

    function find(opts) { return product.variants.filter(function (v) { return v.options.every(function (o, n) { return o === opts[n]; }); })[0]; }

    /* Colour images use the gallery's own size steps, so the background-warmed file is the one a tap asks for. */
    /* Same picture = same file name: the product JSON links cdn.shopify.com/s/files/... while the page's own
       <img> uses the shop's /cdn/shop/files/... path for the same file. */
    function fileName(url) { return String(url || '').split('?')[0].split('/').pop(); }
    function samePic(img, src) {
      var have = img && fileName(img.currentSrc || img.src);
      return !!have && have === fileName(src);
    }
    function variantWidth() { return fitWidth($('[data-variant-slot]', root), [450, 700, 900, 1100]); }

    /* First gallery image downloads alone; the other slides follow, then (unless Save-Data is on) every colour's image. */
    var lead = $('[data-variant-slot] img', root);
    function warmGallery() {
      $$('[data-gallery] img', root).forEach(warmImg);
      afterLoad(function () {
        if (navigator.connection && navigator.connection.saveData) return;
        var w = variantWidth();
        product.variants.forEach(function (v) { if (v.featured_image) warmUrl(sizedUrl(v.featured_image.src, w)); });
      });
    }
    if (!lead || lead.complete) warmGallery();
    else { lead.addEventListener('load', warmGallery, { once: true }); lead.addEventListener('error', warmGallery, { once: true }); }

    function update() {
      var v = find(selected);
      if (!v) return;
      current = v;
      idInput.value = v.id;
      $$('[data-option]', root).forEach(function (b) {
        var n = Number(b.getAttribute('data-option'));
        var on = b.getAttribute('data-value') === selected[n];
        b.setAttribute(b.getAttribute('role') === 'radio' ? 'aria-checked' : 'aria-pressed', on ? 'true' : 'false');
        /* Hide colours that do not exist for the chosen pack. */
        if (b.getAttribute('role') === 'radio') {
          var probe = selected.slice(); probe[n] = b.getAttribute('data-value');
          b.hidden = !find(probe);
        }
      });
      $$('[data-option-label]', root).forEach(function (l) { l.textContent = selected[Number(l.getAttribute('data-option-label'))] || ''; });
      var price = $('[data-price]', root);
      var comp = $('[data-compare]', root);
      var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
      price.textContent = money(v.price);
      price.className = hasCompare ? 'text-coral font-semibold' : '';
      comp.textContent = hasCompare ? money(v.compare_at_price) : '';
      comp.hidden = !hasCompare;
      $$('[data-atc]', root).forEach(function (b) { b.disabled = !v.available; });
      var mainAtc = $('button[type="submit"][data-atc]', form);
      if (mainAtc) mainAtc.textContent = v.available ? 'Add to bag' : 'Sold out';
      var meta = $('[data-sticky-meta]', root);
      if (meta) meta.textContent = (product.variants.length > 1 ? v.title + ' · ' : '') + money(v.price);
      if (v.featured_image) {
        var slot = $('[data-variant-slot]', root);
        /* Leave the slot alone when it already shows this picture: re-pointing it on page load downloaded the first image twice. */
        if (slot && !samePic($('img', slot), v.featured_image.src)) {
          var img = $('img', slot);
          img.removeAttribute('srcset');
          img.src = sizedUrl(v.featured_image.src, variantWidth());
          img.alt = v.featured_image.alt || product.title;
          slot.setAttribute('data-zoom', sizedUrl(v.featured_image.src, 2000));
        }
        var stickyImg = $('[data-sticky-atc] img', root);
        if (stickyImg && !samePic(stickyImg, v.featured_image.src)) { stickyImg.removeAttribute('srcset'); stickyImg.src = sizedUrl(v.featured_image.src, 100); }
        var gal = $('[data-gallery]', root);
        if (gal && gal.scrollLeft) gal.scrollTo({ left: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(null, '', url.toString());
      }
    }

    $$('[data-option]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var n = Number(b.getAttribute('data-option'));
        selected[n] = b.getAttribute('data-value');
        if (!find(selected)) {
          var fallback = product.variants.filter(function (v) { return v.options[n] === selected[n]; })[0];
          if (fallback) selected = fallback.options.slice();
        }
        update();
      });
    });
    update();

    /* Gallery: mobile dots, load more, lightbox */
    var gallery = $('[data-gallery]', root);
    var dots = $$('[data-gallery-dots] .dot', root);
    if (gallery && dots.length) {
      var slides = $$('.gallery-item', gallery);
      var step = function () { return slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : gallery.clientWidth; };
      var current = function () { return Math.round(gallery.scrollLeft / step()); };
      var goTo = function (n) {
        var count = dots.length;
        n = (n + count) % count;
        gallery.scrollTo({ left: n * step(), behavior: reduceMotion ? 'auto' : 'smooth' });
      };
      gallery.addEventListener('scroll', function () {
        var n = current();
        dots.forEach(function (d, m) { d.classList.toggle('is-active', m === n); });
      }, { passive: true });
      dots.forEach(function (d, m) { d.parentElement.addEventListener('click', function () { goTo(m); }); });
      var prev = $('[data-gallery-prev]', root);
      var next = $('[data-gallery-next]', root);
      if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
      if (next) next.addEventListener('click', function () { goTo(current() + 1); });
    }
    var more = $('[data-load-more]', root);
    if (more) more.addEventListener('click', function () { gallery.classList.add('show-all'); more.parentElement.hidden = true; });

    var lb = $('[data-lightbox]');
    if (lb && gallery) {
      var items = $$('[data-zoom]', gallery);
      var idx = 0;
      var lbImg = $('[data-lb-img]', lb);
      var lbCount = $('[data-lb-count]', lb);
      var thumbs = $('[data-lb-thumbs]', lb);
      function show(n) {
        idx = (n + items.length) % items.length;
        lbImg.src = items[idx].getAttribute('data-zoom');
        var im = $('img', items[idx]);
        lbImg.alt = im ? im.alt : '';
        lbCount.textContent = (idx + 1) + ' / ' + items.length;
        $$('button', thumbs).forEach(function (t, m) { t.classList.toggle('border-ink', m === idx); t.classList.toggle('border-transparent', m !== idx); });
      }
      items.forEach(function (it, n) {
        it.addEventListener('click', function () {
          thumbs.textContent = '';
          items.forEach(function (x, m) {
            var t = el('button', 'shrink-0 size-14 border-2 border-transparent');
            t.type = 'button';
            t.setAttribute('aria-label', 'Image ' + (m + 1));
            var ti = el('img', 'size-full object-cover');
            var src = $('img', x);
            ti.src = src ? (src.currentSrc || src.src) : '';
            ti.alt = '';
            t.appendChild(ti);
            t.addEventListener('click', function () { show(m); });
            thumbs.appendChild(t);
          });
          openPanel(lb, { focus: '[data-lb-close]' });
          show(n);
        });
      });
      $('[data-lb-close]', lb).addEventListener('click', function () { closePanel(lb); });
      $('[data-lb-prev]', lb).addEventListener('click', function () { show(idx - 1); });
      $('[data-lb-next]', lb).addEventListener('click', function () { show(idx + 1); });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'ArrowRight') show(idx + 1);
        if (e.key === 'ArrowLeft') show(idx - 1);
      });
    }

    /* Sticky add-to-bag appears once the main button scrolls out of view. */
    var sticky = $('[data-sticky-atc]', root);
    var mainBtn = $('button[type="submit"][data-atc]', form);
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        if (show) { sticky.removeAttribute('inert'); sticky.setAttribute('aria-hidden', 'false'); }
        else { sticky.setAttribute('inert', ''); sticky.setAttribute('aria-hidden', 'true'); }
      }).observe(mainBtn);
    }
  }

  /* Storefront texts from locales/en.default.json (window.HV_T is printed in theme.liquid) */
  function T(key, fallback) { return (window.HV_T && window.HV_T[key]) || fallback; }

  /* Reviews: Sort menu (order + photo filter), search, show more, read more, relative dates, photo strip and viewer */
  function initReviews() {
    $$('[data-reviews]').forEach(function (root) {
      var list = $('[data-review-list]', root);
      if (!list) return;
      var items = $$('[data-review]', list);
      var search = $('[data-review-search]', root);
      var more = $('[data-review-more]', root);
      var empty = $('[data-review-empty]', root);
      var menu = $('[data-sort-menu]', root);
      var panel = menu && $('[data-sort-panel]', menu);
      var toggle = menu && $('[data-sort-toggle]', menu);
      var photoFilter = $('[data-photo-filter]', root);
      var PAGE = 10;
      var limit = PAGE;
      var mode = 'high';
      var onlyPhotos = false;
      function num(li, attr) { return +li.getAttribute(attr) || 0; }
      function date(li) { return li.getAttribute('data-date') || ''; }
      function newer(a, b) { return date(a) === date(b) ? 0 : (date(b) < date(a) ? -1 : 1); }
      function hasPhotos(li) { return !!$('[data-photo-open]', li); }
      function apply() {
        var q = (search.value || '').toLowerCase();
        var sorted = items.slice().sort(function (a, b) {
          if (mode === 'recent') return newer(a, b);
          if (mode === 'old') return -newer(a, b);
          if (mode === 'helpful') return num(b, 'data-helpful-count') - num(a, 'data-helpful-count') || newer(a, b);
          return num(b, 'data-stars') - num(a, 'data-stars') || (hasPhotos(b) - hasPhotos(a)) ||
            num(b, 'data-helpful-count') - num(a, 'data-helpful-count') || newer(a, b);
        });
        var matched = 0;
        sorted.forEach(function (li) {
          var text = $$('[data-review-text]', li).map(function (x) { return x.textContent; }).join(' ').toLowerCase();
          var ok = (!q || text.indexOf(q) !== -1) && (!onlyPhotos || hasPhotos(li));
          if (ok) matched++;
          li.hidden = !ok || matched > limit;
          list.appendChild(li);
        });
        if (empty) empty.hidden = matched > 0;
        if (more) more.hidden = matched <= limit;
        clamp();
      }
      function reset() { limit = PAGE; apply(); }
      function check(btn, on) { var c = $('[data-check]', btn); if (c) c.hidden = !on; }
      if (menu) {
        toggle.addEventListener('click', function (e) {
          e.stopPropagation();
          panel.hidden = !panel.hidden;
          toggle.setAttribute('aria-expanded', String(!panel.hidden));
        });
        document.addEventListener('click', function (e) { if (!menu.contains(e.target)) { panel.hidden = true; toggle.setAttribute('aria-expanded', 'false'); } });
        $$('[data-sort-option]', panel).forEach(function (btn) {
          btn.addEventListener('click', function () {
            mode = btn.getAttribute('data-sort-option');
            $$('[data-sort-option]', panel).forEach(function (x) { check(x, x === btn); });
            reset();
          });
        });
        if (photoFilter) photoFilter.addEventListener('click', function () { onlyPhotos = !onlyPhotos; check(photoFilter, onlyPhotos); reset(); });
        var clear = $('[data-sort-clear]', panel);
        if (clear) clear.addEventListener('click', function () {
          mode = 'high'; onlyPhotos = false; search.value = '';
          $$('[data-sort-option]', panel).forEach(function (x) { check(x, x.getAttribute('data-sort-option') === 'high'); });
          if (photoFilter) check(photoFilter, false);
          reset();
        });
      }
      search.addEventListener('input', reset);
      if (more) more.addEventListener('click', function () { limit += PAGE; apply(); });

      /* Long reviews show 6 lines and a Read more link */
      function clamp() {
        items.forEach(function (li) {
          var body = $('[data-review-body]', li);
          var btn = $('[data-read-more]', li);
          if (!body || !btn || li.hidden || !body.classList.contains('line-clamp-6')) return;
          btn.hidden = body.scrollHeight <= body.clientHeight + 2;
        });
      }
      $$('[data-read-more]', root).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var body = $('[data-review-body]', btn.parentNode);
          if (body) body.classList.remove('line-clamp-6');
          btn.hidden = true;
        });
      });

      /* "1 year ago" style dates, like the reference store */
      function ago(iso) {
        var d = new Date(iso + 'T12:00:00');
        if (isNaN(d)) return '';
        var days = Math.floor((Date.now() - d) / 864e5);
        function unit(n, w) { return n + ' ' + w + (n === 1 ? '' : 's') + ' ago'; }
        if (days < 1) return 'Today';
        if (days < 7) return unit(days, 'day');
        if (days < 30) return unit(Math.floor(days / 7), 'week');
        if (days < 365) return unit(Math.floor(days / 30), 'month');
        return unit(Math.floor(days / 365), 'year');
      }
      $$('[data-review-date]', root).forEach(function (el) {
        var t = ago(el.getAttribute('data-review-date'));
        if (t) { el.title = el.textContent.trim(); el.textContent = t; }
      });

      $$('[data-helpful] button', root).forEach(function (b) {
        b.addEventListener('click', function () { b.classList.add('font-semibold'); b.disabled = true; });
      });

      /* Photo strip arrows: each shows only when there is more to scroll that way */
      var strip = $('[data-photo-strip]', root);
      var stripNext = $('[data-strip-next]', root);
      var stripPrev = $('[data-strip-prev]', root);
      if (strip && stripNext) {
        var stripArrows = function () {
          var max = strip.scrollWidth - strip.clientWidth - 2;
          if (stripPrev) stripPrev.hidden = strip.scrollLeft <= 2;
          stripNext.hidden = strip.scrollLeft >= max;
        };
        stripNext.addEventListener('click', function () { strip.scrollBy({ left: strip.clientWidth * 0.8, behavior: 'smooth' }); });
        if (stripPrev) stripPrev.addEventListener('click', function () { strip.scrollBy({ left: -strip.clientWidth * 0.8, behavior: 'smooth' }); });
        strip.addEventListener('scroll', stripArrows, { passive: true });
        window.addEventListener('resize', stripArrows);
        stripArrows();
      }

      /* Photo viewer: big photo on the left, the review on the right, arrows walk through every photo */
      var viewer = $('[data-photo-viewer]', root);
      if (!viewer) { apply(); return; }
      var photos = $$('[data-photo-open][data-full]', list).sort(function (a, b) { return num(a, 'data-photo-open') - num(b, 'data-photo-open'); });
      var vImg = $('[data-viewer-img]', viewer);
      var current = 0;
      var lastFocus = null;
      function show(i) {
        if (!photos.length) return;
        current = (i + photos.length) % photos.length;
        var btn = photos[current];
        var li = btn.closest('[data-review]');
        vImg.src = btn.getAttribute('data-full');
        $('[data-viewer-name]', viewer).textContent = $('[data-review-name]', li).textContent;
        $('[data-viewer-stars]', viewer).innerHTML = $('[data-review-stars]', li).innerHTML;
        var texts = $$('[data-review-text]', li);
        $('[data-viewer-title]', viewer).textContent = texts[0] ? texts[0].textContent : '';
        $('[data-viewer-text]', viewer).innerHTML = texts[1] ? texts[1].innerHTML : '';
        $('[data-viewer-date]', viewer).textContent = $('[data-review-date]', li).textContent;
      }
      function open(i) {
        lastFocus = document.activeElement;
        show(i);
        viewer.classList.remove('hidden');
        viewer.classList.add('flex');
        document.documentElement.style.overflow = 'hidden';
        $('[data-viewer-close]', viewer).focus();
      }
      function close() {
        viewer.classList.add('hidden');
        viewer.classList.remove('flex');
        document.documentElement.style.overflow = '';
        if (lastFocus) lastFocus.focus();
      }
      $$('[data-photo-open]', root).forEach(function (btn) {
        btn.addEventListener('click', function () { open(num(btn, 'data-photo-open')); });
      });
      $('[data-viewer-prev]', viewer).addEventListener('click', function () { show(current - 1); });
      $('[data-viewer-next]', viewer).addEventListener('click', function () { show(current + 1); });
      $('[data-viewer-close]', viewer).addEventListener('click', close);
      viewer.addEventListener('click', function (e) { if (e.target === viewer) close(); });
      document.addEventListener('keydown', function (e) {
        if (viewer.classList.contains('hidden')) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') show(current - 1);
        if (e.key === 'ArrowRight') show(current + 1);
      });
      apply();
    });
  }

  /* Product page extras: See it in action player, feature card dots, video stories */
  function initProductExtras() {
    var player = $('[data-story-player]');
    var pv = player && $('[data-story-video]', player);
    function closePlayer() { if (!player) return; pv.pause(); player.hidden = true; }
    $$('[data-story-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!player) return;
        var src = btn.getAttribute('data-src');
        if (pv.getAttribute('src') !== src) pv.setAttribute('src', src);
        player.hidden = false;
        var p = pv.play();
        if (p && p.catch) p.catch(function () {});
      });
    });
    if (player) {
      $('[data-story-close]', player).addEventListener('click', closePlayer);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !player.hidden) closePlayer(); });
    }

    $$('[data-cards]').forEach(function (root) {
      var track = $('[data-cards-track]', root);
      var dots = $$('[data-cards-dot]', root);
      if (!track || !dots.length) return;
      function active() {
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        dots.forEach(function (d, k) { d.classList.toggle('bg-ink', k === i); d.classList.toggle('bg-line', k !== i); });
      }
      track.addEventListener('scroll', active, { passive: true });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { track.scrollTo({ left: k * track.clientWidth, behavior: 'smooth' }); }); });
    });

    $$('[data-vs]').forEach(function (root) {
      var track = $('[data-vs-track]', root);
      var cards = $$('[data-vs-card]', root);
      function step() { return cards[0] ? cards[0].getBoundingClientRect().width + 16 : track.clientWidth; }
      var prev = $('[data-vs-prev]', root);
      var next = $('[data-vs-next]', root);
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      cards.forEach(function (card) {
        var v = $('[data-vs-video]', card);
        var play = $('[data-vs-play]', card);
        play.addEventListener('click', function () {
          $$('[data-vs-video]', root).forEach(function (o) { if (o !== v) { o.pause(); } });
          play.hidden = true;
          v.controls = true;
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        });
        v.addEventListener('ended', function () { play.hidden = false; v.controls = false; });
      });
    });
  }

  /* ---------------------------------------------------------------- collection */
  function initCollection() {
    var root = $('[data-collection]');
    if (!root) return;
    var sort = $('[data-sort]', root);
    if (sort) sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
    var cards = $$('[data-type]', root);
    var active = null;
    function apply() {
      var shown = 0;
      cards.forEach(function (c) { c.hidden = active && c.getAttribute('data-type') !== active; if (!c.hidden) shown++; });
      $$('[data-type-filter]', root).forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-type-filter') === active); });
      $$('[data-count]', root).forEach(function (n) { n.textContent = shown; });
      var clear = $('[data-clear-filter]', root);
      if (clear) clear.hidden = !active;
      var empty = $('[data-empty]', root);
      if (empty) empty.hidden = shown > 0;
    }
    $$('[data-type-filter]', root).forEach(function (b) {
      b.addEventListener('click', function () { var t = b.getAttribute('data-type-filter'); active = active === t ? null : t; apply(); });
    });
    var clear = $('[data-clear-filter]', root);
    if (clear) clear.addEventListener('click', function () { active = null; apply(); });
    var filters = $('[data-filters]', root);
    var openBtn = $('[data-open-filters]', root);
    if (filters && openBtn) {
      openBtn.addEventListener('click', function () { openPanel(filters); });
      $$('[data-close-filters]', filters).forEach(function (b) { b.addEventListener('click', function () { closePanel(filters); }); });
    }
  }

  /* ---------------------------------------------------------------- popup */
  var popup, popupDialog, popupTeaser, popupKey;
  function store(v) { try { if (v == null) return localStorage.getItem(popupKey); localStorage.setItem(popupKey, v); } catch (e) { return null; } }
  function popupClose() {
    closePanel(popupDialog);
    if (store() !== 'claimed') { store('closed'); popupTeaser.hidden = false; }
  }
  function stage(name) { $$('[data-stage]', popup).forEach(function (s) { s.hidden = s.getAttribute('data-stage') !== name; }); }
  function initPopup() {
    popup = $('[data-popup]');
    if (!popup) return;
    popupDialog = $('[data-popup-dialog]', popup);
    popupTeaser = $('[data-popup-teaser]', popup);
    popupKey = popup.getAttribute('data-key') || 'hv-popup';
    var state = store();
    var inEditor = window.Shopify && window.Shopify.designMode;
    /* Download the popup images ahead of time (they are lazy in the markup) so the dialog opens fully drawn. */
    var warm = function () { $$('img', popupDialog).forEach(function (img) { img.loading = 'eager'; }); };
    if (state !== 'claimed') {
      if (!state && theme.template === 'index') warm();
      else if (document.readyState === 'complete') setTimeout(warm, 1500);
      else window.addEventListener('load', function () { setTimeout(warm, 1500); });
    }

    popupTeaser.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-hide]')) { popupTeaser.hidden = true; return; }
      popupTeaser.hidden = true;
      openPanel(popupDialog, { focus: '[data-popup-close]' });
    });
    $('[data-popup-hide]', popupTeaser).addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); popupTeaser.hidden = true; }
    });
    $('[data-popup-close]', popupDialog).addEventListener('click', popupClose);
    $('[data-popup-shop]', popupDialog).addEventListener('click', function () { closePanel(popupDialog); });

    var flipped = 0;
    $$('[data-flip]', popupDialog).forEach(function (card, n) {
      card.addEventListener('click', function () {
        if (card.classList.contains('is-flipped') || flipped >= 3) return;
        card.classList.add('is-flipped');
        card.setAttribute('aria-label', 'Card revealed');
        flipped++;
        if (flipped === 3) setTimeout(function () { stage('won'); }, 700);
      });
    });

    var form = $('form', popupDialog);
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } }).catch(function () {});
      store('claimed');
      stage('claimed');
    });

    if (inEditor) { popupTeaser.hidden = false; return; }
    if (state === 'claimed') return;
    if (state) { popupTeaser.hidden = false; return; }
    if (theme.template !== 'index') return;
    setTimeout(function () {
      if (openLayer) { store('seen'); popupTeaser.hidden = false; return; }
      store('seen');
      openPanel(popupDialog, { focus: '[data-popup-close]' });
    }, Number(popup.getAttribute('data-delay')) || 3500);
  }

  /* Confirm prompts for destructive account actions */
  function initConfirm() {
    $$('form[data-confirm]').forEach(function (f) {
      f.addEventListener('submit', function (e) { if (!window.confirm(f.getAttribute('data-confirm'))) e.preventDefault(); });
    });
  }

  /* Form validation messages in the store's language (English), whatever the visitor's browser language is. */
  function initValidation() {
    document.addEventListener('invalid', function (e) {
      var f = e.target;
      if (!f.setCustomValidity) return;
      var v = f.validity;
      var msg = T('invalid', 'Please enter a valid value.');
      if (v.valueMissing) {
        if (f.type === 'checkbox') msg = T('checkbox', 'Please check this box to continue.');
        else if (f.type === 'email') msg = T('required', 'Please fill out this field.');
        else if (f.tagName === 'SELECT') msg = T('select', 'Please select an option.');
        else msg = T('required', 'Please fill out this field.');
      } else if (v.typeMismatch && f.type === 'email') msg = T('email', 'Please enter a valid email address, like name@example.com.');
      else if (v.rangeUnderflow) msg = 'Please enter ' + f.min + ' or more.';
      else if (v.rangeOverflow) msg = 'Please enter ' + f.max + ' or less.';
      else if (v.tooShort) msg = 'Please use at least ' + f.minLength + ' characters.';
      f.setCustomValidity(msg);
    }, true);
    ['input', 'change'].forEach(function (type) {
      document.addEventListener(type, function (e) { if (e.target.setCustomValidity) e.target.setCustomValidity(''); }, true);
    });
  }

  function init() {
    initValidation();
    initHeader();
    initCollapsibles();
    initSearch();
    initCart();
    initReveal();
    initImgFade();
    initHero();
    initTabs();
    initSliders();
    initCards();
    initProduct();
    initReviews();
    initProductExtras();
    initCollection();
    initPopup();
    initWarm();
    initConfirm();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Theme editor: re-run setup when a section is reloaded. */
  document.addEventListener('shopify:section:load', function () { initReveal(); initImgFade(); initHero(); initTabs(); initSliders(); });
  document.addEventListener('shopify:section:select', function (e) {
    if (popupDialog && e.target.contains(popupDialog)) { stage('game'); openPanel(popupDialog); }
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (popupDialog && e.target.contains(popupDialog)) closePanel(popupDialog);
  });
})();
